import { axiosAPI } from './API';
import { ILocationGroup } from 'interfaces';

// Singleton for interacting with locations
class _LocationGroupsService {

    public locationGroups: ILocationGroup[] = [];
    public locationGroupsMap: {[id: string]: ILocationGroup} = {};

    public getAllLocationGroups = (): Promise<ILocationGroup[]> => {
        return axiosAPI.get<ILocationGroup[]>("/locationGroups")
            .then((resp) => {
                let locationGroupsResponse = resp.data;
                // save to cache
                this.locationGroups = locationGroupsResponse;
                locationGroupsResponse.forEach((g) => this.locationGroupsMap[g.id] = g);
                // filter deleted
                this.locationGroups = this.locationGroups.filter(g => !g.isDeleted);
                // sort
                this.locationGroups.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                })
                return locationGroupsResponse;
            })
            .catch((err) => {
                console.error("Error getting all location groups: ", err);
                throw err;
            });
    }

    public postLocationGroup = (group: Omit<ILocationGroup, "id">): Promise<ILocationGroup> => {        
        return axiosAPI.post<ILocationGroup>('/locationGroups', group)
            .then((resp) => {
                let locationGroup: ILocationGroup = {
                    id: resp.data.id,
                    ...group
                };
                // save to cache
                this.locationGroups.push(locationGroup);
                this.locationGroupsMap[locationGroup.id] = locationGroup;
                // sort
                this.locationGroups.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                })
                return resp.data;
            })
            .catch((err) => {
                console.error("Error posting location group: ", err);
                throw err;
            });
    }

    public putLocationGroup = (id, group: Omit<ILocationGroup, "id">): Promise<ILocationGroup> => {

        let url = `/locationGroups/${id}`;
                
        return axiosAPI.put<ILocationGroup>(url, group)
            .then((resp) => {
                let locationGroup: ILocationGroup = {
                    id: id,
                    ...group
                };
                // update cache
                const i = this.locationGroups.findIndex(g => g.id === locationGroup.id);
                this.locationGroups.splice(i, 1, locationGroup);
                this.locationGroupsMap[locationGroup.id] = locationGroup;
                return resp.data;
            })
            .catch((err) => {
                console.error("Error putting location group: ", err);
                throw err;
            });
    }

    public deleteLocationGroup = (id: number): Promise<any> => {

        let url = `/locationGroups/${id}`;

        return axiosAPI.delete(url)
            .then(() => {
                // remove from list
                this.locationGroups = this.locationGroups.filter(g => g.id != id);
                this.locationGroupsMap[id].isDeleted = true;
                return;
            })
            .catch((err) => {
                console.error("Error deleting location group: ", err);
                throw err;
            });
    }
}

export const LocationGroupsService = new _LocationGroupsService();